// extracted by mini-css-extract-plugin
export var aircallIframe = "_jx-3";
export var fabContainer = "_jx-5";
export var fabRinging = "_jx-6";
export var loadingOverlay = "_jx-4";
export var pulse = "_jx-7";
export var widgetContent = "_jx-2";
export var widgetPanel = "_jx-0";
export var widgetPanelExpanded = "_jx-1";